import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRunNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M11.37 24.17l-2.31-2.34H6.74l2.31 2.34z" />
        <path d="M5.1 20.17h2.31l-5.25-5.31a1.253 1.253 0 01-.33-1.15 1.23 1.23 0 01.77-.91l.58-.23 11.75 11.6h2.34L4.41 11.48l4.36-8.26a.757.757 0 011.188-.175c.14.139.22.328.222.525v4.94a3.325 3.325 0 003.32 3.32h.5l1.37-2.66a1.82 1.82 0 011.61-1 1.793 1.793 0 011.59.96l1.78 3.33L17 14.24v1.87l4.13-2.19 1.12 2.11-3.71 1.98v1.87l4.49-2.39 1.09 2.04L20 21.72v1.87l4.9-2.6 2.688 5.08h.612a1.984 1.984 0 011.71 2.96l-.07.12a2.025 2.025 0 01-1.76 1.02h-4.95a14.028 14.028 0 01-9.92-4.14l-.21-.21h-2.32l1.35 1.37a15.694 15.694 0 0011.1 4.64h4.95a3.715 3.715 0 003.2-1.86l.07-.13a3.616 3.616 0 00-2.73-5.38l-8.6-16.11a3.442 3.442 0 00-6.12.07l-.87 1.69a1.665 1.665 0 01-1.2-1.6V3.57a2.407 2.407 0 00-2.4-2.4 2.37 2.37 0 00-2.11 1.28l-4.5 8.49-.82.32a2.912 2.912 0 00-1.01 4.75z" />
      </g>
    </svg>
  )
);
SvgSportsRunNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsRunNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRunNormalMedium;
